import React from 'react';
export const PlusProfile = _ref => {
  let {
    color1 = '#2AB6B9',
    color2 = '#202020',
    size = '35'
  } = _ref;
  return React.createElement("svg", {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 36 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    className: "inverse",
    y: "14",
    width: "2",
    height: "9",
    fill: color1
  }), React.createElement("rect", {
    className: "inverse",
    x: "4",
    y: "9",
    width: "2",
    height: "14",
    fill: color1
  }), React.createElement("rect", {
    className: "inverse",
    x: "8",
    y: "14",
    width: "2",
    height: "9",
    fill: color1
  }), React.createElement("rect", {
    className: "inverse",
    x: "12",
    y: "3",
    width: "2",
    height: "20",
    fill: color1
  }), React.createElement("mask", {
    id: "path-5-inside-1_1_4295",
    fill: "white"
  }, React.createElement("path", {
    d: "M13 23.2499C13 20.2663 14.1853 17.4048 16.295 15.295C18.4048 13.1852 21.2663 11.9999 24.25 11.9999C27.2337 11.9999 30.0952 13.1852 32.205 15.295C34.3147 17.4048 35.5 20.2663 35.5 23.2499L24.25 23.2499H13Z"
  })), React.createElement("path", {
    className: "inverse",
    d: "M13 23.2499C13 20.2663 14.1853 17.4048 16.295 15.295C18.4048 13.1852 21.2663 11.9999 24.25 11.9999C27.2337 11.9999 30.0952 13.1852 32.205 15.295C34.3147 17.4048 35.5 20.2663 35.5 23.2499L24.25 23.2499H13Z",
    fill: "#F1F1F1",
    stroke: color2,
    strokeWidth: "2",
    mask: "url(#path-5-inside-1_1_4295)"
  }), React.createElement("circle", {
    cx: "5.625",
    cy: "5.625",
    r: "5.125",
    transform: "matrix(-1 0 0 1 29.25 0)",
    stroke: color2
  }));
};